<template>
  <div class="publicList">
    <van-nav-bar title="公告列表"
                 class="title">
      <img src="@/assets/back.png"
           slot="left"
           class="img"
           @click="$router.back()">
    </van-nav-bar>
    <div v-for="item in noticeList"
              :key="item.id" style="padding: 0 12px; font-size: 14px; color: #666666;margin-top: 6px;">
      <div slot="title" v-html="item.content"></div>
      <p style="margin: 10px 0;">{{item.createTime}}</p>
    </div>
  </div>
</template>

<script>
import { getSysNoticeList } from '@/api/notice'
export default {
  name: 'publicList',
  data () {
    return {
      noticeList: []
    }
  },
  created () {
    this.getNotice()
  },
  methods: {
    getNotice () {
      getSysNoticeList({}).then(res => {
        if (res.success) {
          this.noticeList = res.data
          console.log(this.noticeList);
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.publicList {
  .title {
    background-color: #f3f3f3;
    width: 100%;
  }
  .img {
    width: 29px;
    height: 29px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/modules/publicList.vue